import { apiFilesBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const auxImagesApiRoutes = {
    list: apiFilesBaseURL + "aux-images/",
    listTransportAuthority: apiFilesBaseURL + "aux-images/ta/",
    create: apiFilesBaseURL + "aux-images/",
    createTransportAuthority: apiFilesBaseURL + "aux-images/ta/",
    update: apiFilesBaseURL + "aux-images/",
    updateTransportAuthority: apiFilesBaseURL + "aux-images/ta/",
    delete: apiFilesBaseURL + "aux-images/",
    deleteTransportAuthority: apiFilesBaseURL + "aux-images/ta/",
    uploadImage: apiFilesBaseURL + "aux-images/upload/",
};

export class AuxImagesAPI {
    static create(formData) {
        var request = {
            url: auxImagesApiRoutes.create,
            method: HTTPMethod.POST,
            contentType: ContentType.MULTIPART,
            token: authenticationCentral.accessToken,
            body: formData
        };
        return API.authenticatedRequest(request);
    }
    
    static createTransportAuthority(formData) {
        var request = {
            url: auxImagesApiRoutes.createTransportAuthority,
            method: HTTPMethod.POST,
            contentType: ContentType.MULTIPART,
            token: authenticationCentral.accessToken,
            body: formData
        };
        return API.authenticatedRequest(request);
    }

    static update(pictogramId, pictogram) {
        return API.authenticatedRequest({
            url: auxImagesApiRoutes.update + pictogramId,
            method: HTTPMethod.PATCH,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(pictogram)
        });
    }

    static updateTransportAuthority(pictogramId, pictogram) {
        return API.authenticatedRequest({
            url: auxImagesApiRoutes.updateTransportAuthority + pictogramId,
            method: HTTPMethod.PATCH,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(pictogram)
        });
    }

    static delete(pictogramId) {
        return API.authenticatedRequest({
            url: auxImagesApiRoutes.delete + pictogramId,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static deleteTransportAuthority(pictogramId) {
        return API.authenticatedRequest({
            url: auxImagesApiRoutes.deleteTransportAuthority + pictogramId,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static list(provider = '') {
        const url = auxImagesApiRoutes.list;

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?providerId=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static listTransportAuthority() {
        const url = auxImagesApiRoutes.listTransportAuthority;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static uploadImage(formData) {
        var request = {
            url: auxImagesApiRoutes.uploadImage,
            method: HTTPMethod.POST,
            contentType: ContentType.MULTIPART,
            token: authenticationCentral.accessToken,
            body: formData
        };
        return API.authenticatedRequest(request);
    }
}
